import { getLandingBaseUrl } from 'src/locales/utils';

export const LandingUrl = getLandingBaseUrl();
